"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixinLabel = exports.wrap = exports.spyModel = exports.inject = exports.withLabel = void 0;
const getter_1 = require("../types/getter");
function withLabel(model, label) {
    const _label = label;
    Object.defineProperty(model, 'label', {
        configurable: true,
        enumerable: false,
        get() { return getter_1.Getter.getValue(_label); },
    });
    return model;
}
exports.withLabel = withLabel;
function inject(model, source) {
    Object.defineProperty(model, 'value', {
        configurable: true,
        enumerable: false,
        get() { return source.value; },
        set(v) { source.value = v; },
    });
    return model;
}
exports.inject = inject;
/**
 * Adds callbacks to setter and getter of the 'value' property of a model. DOES NOT override previous spies (all spies are in charge).
 *
 * Useful mostly for debugging.
 * */
function spyModel(model, spySetter, spyGetter) {
    const descriptor = Object.getOwnPropertyDescriptor(model, 'value');
    const valueSetter = descriptor === null || descriptor === void 0 ? void 0 : descriptor.set;
    const valueGetter = descriptor === null || descriptor === void 0 ? void 0 : descriptor.get;
    let _overrideValue = descriptor ? descriptor.value : model.value;
    Object.defineProperty(model, 'value', {
        configurable: true,
        set(v) {
            spySetter(v);
            if (valueSetter) {
                valueSetter.call(model, v);
            }
            else {
                _overrideValue = v;
            }
        },
        get() {
            let res = null;
            if (valueGetter) {
                res = valueGetter.call(model);
            }
            else {
                res = _overrideValue;
            }
            spyGetter === null || spyGetter === void 0 ? void 0 : spyGetter(res);
            return res;
        },
    });
}
exports.spyModel = spyModel;
function wrap(model, getter, setter) {
    return {
        get value() { return getter(model); },
        set value(v) { setter(v, model); },
    };
}
exports.wrap = wrap;
function mixinLabel(Superclass) {
    // @ts-ignore
    class Sub extends Superclass {
        constructor(label, initial) {
            super(initial);
            withLabel(this, label);
        }
    }
    return Sub;
}
exports.mixinLabel = mixinLabel;
//# sourceMappingURL=wrappers.js.map